import React from "react";
import { Modal, Platform, Linking } from "react-native";
import { View, Text, Button } from "@src/components";
import { StyleSheet, useUnistyles } from "react-native-unistyles";
import LogoIcon from "@src/assets/svgs/logo-icon.svg";
import LogoType from "@src/assets/svgs/logo-type.svg";

interface ForceUpgradeModalProps {
  visible: boolean;
  upgradeMessage?: string;
  appStoreUrl?: string;
  playStoreUrl?: string;
}

export const ForceUpgradeModal: React.FC<ForceUpgradeModalProps> = ({
  visible,
  upgradeMessage = "A new version of the app is available. Please update to continue.",
  appStoreUrl,
  playStoreUrl,
}) => {
  const { theme } = useUnistyles();
  const isDarkMode = theme.currentTheme === "dark";
  const storeUrl = Platform.OS === "ios" ? appStoreUrl : playStoreUrl;
  const handleUpdatePress = () => {
    if (storeUrl) {
      Linking.openURL(storeUrl).catch((error) => {
        console.error("[Force Upgrade] Failed to open store URL:", error);
      });
    }
  };
  return (
    <Modal
      visible={visible}
      animationType="fade"
      transparent={true}
      onRequestClose={() => {
        // Do nothing - modal cannot be dismissed
      }}
    >
      {/* Semi-transparent dark overlay */}
      <View
        style={{
          flex: 1,
          backgroundColor: "rgba(0, 0, 0, 0.8)",
          justifyContent: "center",
          alignItems: "center",
          padding: theme.spacing["4xl"],
        }}
      >
        {/* Alert-style modal content */}
        <View
          style={{
            backgroundColor: theme.colors.background,
            borderRadius: theme.spacing.xl,
            padding: theme.spacing["4xl"],
            width: "85%",
            alignItems: "center",
            shadowColor: "#000",
            shadowOffset: {
              width: 0,
              height: 2,
            },
            shadowOpacity: 0.25,
            shadowRadius: 4,
            elevation: 5,
          }}
        >
          {/* Smaller icon for alert style */}
          <View flexDirection="row" alignItems="center" gap="md">
            <LogoIcon width={55} height={50} />
            <LogoType width={115} height={50} style={styles.logoType} />
          </View>

          {/* Title */}
          <Text
            textStyle="h4"
            style={{
              textAlign: "center",
              marginBottom: theme.spacing["2xl"],
            }}
          >
            Update Required
          </Text>

          {/* Message */}
          <Text
            textStyle="sm/regular"
            style={{
              textAlign: "center",
              color: theme.colors.textMuted,
              marginBottom: theme.spacing["4xl"],
              lineHeight: 20,
            }}
          >
            {upgradeMessage}
          </Text>

          {/* Update Button - full width like system alerts */}
          <Button onPress={handleUpdatePress} size="md" variant="primary" label="Update Now" textStyle="sm/medium" />

          {/* Small note */}
          <Text
            textStyle="sm/regular"
            style={{
              textAlign: "center",
              color: theme.colors.textMuted,
              marginTop: theme.spacing["2xl"],
            }}
          >
            Required to continue
          </Text>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create((theme) => ({
  logoType: {
    color: theme.colors.text,
  },
}));
